var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F6F1FE",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 28.3333H13.3334V26.6667C13.3334 25.5616 13.7724 24.5018 14.5538 23.7204C15.3352 22.939 16.395 22.5 17.5 22.5H22.5C23.6051 22.5 24.6649 22.939 25.4463 23.7204C26.2277 24.5018 26.6667 25.5616 26.6667 26.6667V28.3333ZM20 20.8333C19.3434 20.8333 18.6933 20.704 18.0866 20.4527C17.48 20.2015 16.9288 19.8332 16.4645 19.3689C16.0002 18.9046 15.6319 18.3534 15.3806 17.7468C15.1294 17.1401 15 16.49 15 15.8333C15 15.1767 15.1294 14.5266 15.3806 13.9199C15.6319 13.3133 16.0002 12.7621 16.4645 12.2978C16.9288 11.8335 17.48 11.4652 18.0866 11.2139C18.6933 10.9627 19.3434 10.8333 20 10.8333C21.3261 10.8333 22.5979 11.3601 23.5356 12.2978C24.4733 13.2355 25 14.5073 25 15.8333C25 17.1594 24.4733 18.4312 23.5356 19.3689C22.5979 20.3066 21.3261 20.8333 20 20.8333Z",
    fill: "#F8F9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.30e9e6af0139b05da59fa8de3fc7b9a6.svg";
export { ForwardRef as ReactComponent };